import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function getTaskDocuments(url, resource, payload) {
	return {
		type: types.GET_TASK_DOCUMENTS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		},
		resolve: true,
		...payload
	};
}

export function getEvidences(url, resource) {
	return {
		type: types.GET_EVIDENCES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getTaskDocumentsStatusAndFlagsOnly(url, resource) {
	return {
		type: types.GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function resetTaskDocuments() {
	return {
		type: types.RESET_TASK_DOCUMENTS
	};
}

export function tempRemoveDocument(documentId, documentType) {
	return {
		type: types.TEMP_REMOVE_DOCUMENT,
		documentId,
		documentType
	};
}

export function associateTaskDocuments(url, data, documentName, payload) {
	return {
		type: types.ASSOCIATE_TASK_DOCUMENTS,
		meta: {
			api: {
				url: url,
				method: data.operationType === 1 ? 'POST' : 'DELETE',
				data: data
			}
		},
		documentName,
		payload
	};
}

export function createDocumentCopy(engagementId, documentId, copyArgs) {
	const docUrl = `${env.getDocServiceUrl('documents.json')}`;
	return {
		type: types.CREATE_DOCUMENT_COPY,
		documentId: documentId,
		resolve: true,
		meta: {
			api: {
				url: docUrl,
				method: 'POST',
				headers: {
					engagementid: engagementId,
					'X-COPY-FROM': documentId,
					ignorefiletypevalidation: true
				},
				data: copyArgs
				//trackWithArea: `${promiseAreas.GET_DOCUMENT_TASKDETAILS}_${documentId}`
			}
		}
	};
}

export function createTaskDocumentRelation(engagementId, relatedDocumentId, documentName, taskIds) {
	const requestsUrl = env.getBaseURL(serviceURL, engagementId) + 'TaskDocuments';
	const body = {
		DocumentId: relatedDocumentId,
		operationType: 1,
		taskIds: taskIds
	};

	return associateTaskDocuments(requestsUrl, body, documentName, {functionType: 'Relate'});
}
